var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFdusd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.8 141.7",
    style: {
      enableBackground: "new 0 0 141.8 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#00E98D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9,141.7L70.9,141.7C31.7,141.7,0,110,0,70.9l0,0C0,31.7,31.7,0,70.9,0l0,0c39.1,0,70.9,31.7,70.9,70.9l0,0  C141.7,110,110,141.7,70.9,141.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.43495,-0.68691) scale(1.24272,1.24272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000049194608071894037950000002340421401985118635_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.8,49 9.8,62.4 -27,62.4 -27,27.4 9.8,27.4 9.8,40.8 -11.8,40.8 -11.8,49    "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55.4,
    y: 70.2,
    className: "st1",
    width: 45.8,
    height: 19.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdusd);
export default __webpack_public_path__ + "static/media/FDUSD.a7b0e3ec34fea50adec9a510c4006831.svg";
export { ForwardRef as ReactComponent };